import { intFmt } from "../chart-formatters";

export function TooltipContent({
  title,
  rows,
  children
}) {
  return (
    <div className="overflow-hidden">
      <div className="px-2.5 py-2">
        {title && (
          <div
            className="mb-1.5 text-left font-semibold text-[11px] text-chart-tooltip-muted uppercase tracking-wide">
            {title}
          </div>
        )}
        <div className="space-y-1">
          {rows.map((row) => (
            <div
              className="flex items-center justify-between gap-5"
              key={`${row.label}-${row.color}`}>
              <div className="flex min-w-0 items-center gap-1.5">
                <span
                  className="h-1.5 w-1.5 shrink-0 rounded-full"
                  style={{ backgroundColor: row.color }} />
                <span className="truncate text-[11.5px] text-chart-tooltip-muted">
                  {row.label}
                </span>
              </div>
              <span
                className="font-semibold text-[11.5px] text-chart-tooltip-foreground tabular-nums">
                {typeof row.value === "number" ? intFmt(row.value) : row.value}
              </span>
            </div>
          ))}
        </div>

        {children && (
          <div className="mt-1.5 transition-opacity duration-200 ease-out">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}

TooltipContent.displayName = "TooltipContent";

export default TooltipContent;
